// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2eRvG","content":"RecentSearches_content__1F90v"};